function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(198.38 -60.698)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.21767 0 0 .21702 -296.29 30.236)",
  stroke: "#fff",
  strokeWidth: 3.652
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.2155 0 0 1.2192 449.81 140.37)",
  d: "m7.5098 0a3 3 0 0 0-2.5938 1.5h-4.916v3h4.916a3 3 0 0 0 2.5938 1.5 3 3 0 0 0 2.5918-1.5h15.898v-3h-15.896a3 3 0 0 0-2.5938-1.5zm0 2a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1z",
  stroke: "none"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .26056)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.21767 0 0 .21702 -296.29 32.621)",
  stroke: "#fff",
  strokeWidth: 3.652
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.2155 0 0 1.2192 449.81 128.18)",
  d: "m19.709 10a3 3 0 0 0-2.5938 1.5h-17.115v3h17.115a3 3 0 0 0 2.5938 1.5 3 3 0 0 0 2.5938-1.5h3.6973v-3h-3.6973a3 3 0 0 0-2.5938-1.5zm0 2a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1z",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .79375)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.21767 0 0 .21702 -296.29 34.734)",
  stroke: "#fff",
  strokeWidth: 3.652
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(1.2155 0 0 1.2192 449.81 115.98)",
  d: "m13.008 20a3 3 0 0 0-2.5938 1.5h-10.414v3h10.414a3 3 0 0 0 2.5938 1.5 3 3 0 0 0 2.5938-1.5h10.398v-3h-10.398a3 3 0 0 0-2.5938-1.5zm0 2a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1z",
  stroke: "none"
}))));

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 6.8792 6.8792",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.1ce73b6f.svg";
export { ForwardRef as ReactComponent };